import moment from 'moment';
import { serverDateFormat } from './serverTime';

export const checkIfPeriodOverlap = (
  list: {
    start?: string;
    end?: string;
  }[],
  date: string | undefined
) => {
  return list?.some((item) =>
    moment(date).isBetween(
      moment(item.start),
      moment(item.end),
      undefined,
      '[]'
    )
  );
};

export const validateStartDate = (
  start: string | undefined,
  end: string | undefined
) => {
  const startDate = start ? moment(start).local() : null;
  const endDate = end ? moment(end).local() : null;
  return !(startDate && endDate && startDate?.isAfter(endDate));
};

export const isActive = (start?: string, end?: string) =>
  moment().isBetween(start, end) || (!end && moment().isAfter(start));

export const isValidDate = (date: string) =>
  moment(date, serverDateFormat, true).isValid();

export const isValidDateTime = (date: string) =>
  moment(date, `${serverDateFormat}THH:mm`, true).isValid() ||
  moment(date, `${serverDateFormat}THH:mm:ss`, true).isValid() ||
  moment(date, `${serverDateFormat}THH:mmZ`, true).isValid() ||
  moment(date, `${serverDateFormat}THH:mm:ssZ`, true).isValid();
